import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FilterFieldComponent } from '../filter-field.component';
import { SearchSelectFilterField } from './filter-field-search-select';

@Component({
  selector: 'va-filter-search-select',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['filter-field-search-select.scss'],
  template: `
    <div [ngClass]="{ 'search-select-with-title': filterField.title }">
      @if (filterField.title) {
        <div class="filter-title">
          {{ '' + filterField.title | translate }}
        </div>
      }
      <uikit-search-select
        [width]="filterField.searchSelectFieldWidth()"
        [options]="filterField.options"
        [displayProperty]="filterField.optionDisplayProperty"
        [showSearch]="filterField.showSearch"
        [selected]="filterField.value"
        [placeholderText]="filterField.placeholder"
        [dropdownWidth]="filterField.dropdownWidth"
        [closeOnClick]="filterField.closeOnClick"
        (selection)="applyFilter($event)"
        />
    </div>
    `,
  standalone: false,
})
export class SearchSelectFilterFieldComponent extends FilterFieldComponent<SearchSelectFilterField> {}
